import { defineMessages } from 'react-intl';
import * as Actions from '../../../create-label-content/create-label-content.actions';

const messages = defineMessages({
  createLabel: {
    description: 'cswPrimaryActions.createLabel',
    defaultMessage: 'Create Label',
    id: '25p4PC',
  },
});

export const createLabel = {
  id: 'createLabel',
  translation: messages.createLabel,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId, labelMetadata) => {
    return Actions.createLabel({
      fulfillmentPlanId,
      doNotPrint: true,
      labelMetadata,
    });
  },
};
